import { useMemo } from 'react';
import { useI18n } from '@shared/i18n/useI18n';
import type { TPreviewLabels } from '../types';

export const useMessageLabels = (): TPreviewLabels => {
    const { t } = useI18n();
    return useMemo(
        () => ({
            you: t('screens.chat.list.you'),
            image: t('screens.chat.list.preview.image'),
            video: t('screens.chat.list.preview.video'),
            audio: t('screens.chat.list.preview.audio'),
            voice: t('screens.chat.list.preview.voice'),
            attachment: t('screens.chat.list.preview.attachment'),
            message: t('screens.chat.list.preview.message'),
        }),
        [t],
    );
};
